import React from "react";
import {
  Box,
  Container,
  Typography,
  Button,
  useTheme,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

interface ComingSoonProps {
  title?: string;
  description?: string;
  showBackButton?: boolean;
  customBackPath?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  title = "Coming Soon!",
  description = "We're working hard to bring you something amazing. Stay tuned!",
  showBackButton = true,
  customBackPath,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleBack = () => {
    if (customBackPath) {
      navigate(customBackPath);
    } else {
      navigate(-1);
    }
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h2"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 500,
            color: theme.palette.primary.main,
            mb: 3,
          }}
        >
          {title}
        </Typography>

        <Typography
          variant="body1"
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          {description}
        </Typography>

        {showBackButton && (
          <Button
            startIcon={<ArrowBack />}
            variant="text"
            onClick={handleBack}
            sx={{ mt: 2 }}
          >
            Go Back
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default ComingSoon;
